import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState
} from 'react';
//import { BigNumber } from 'ethers';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Form, Button, ProgressBar } from 'react-bootstrap'

//CFX v1 Contract LIVE
import ERC20GameTokenV1Artifact from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import ERC20GameTokenV1Address from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//CFX v2 Contract LIVE
import ERC20GameTokenV2Artifact from '../live_artifacts/contracts/CosmicForceTokenV2.sol/CosmicForceTokenV2.json';
import ERC20GameTokenV2Address from '../live_artifacts/contracts/CosmicForceTokenV2.sol/CosmicForceTokenV2-address.json';

//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//CFALPHA LIVE
import CFALPHA_Artifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

//CFOG LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

//CFOG LIVE
import CosmicTokenSwapArtifact from '../live_artifacts/contracts/CosmicTokenSwap.sol/CosmicTokenSwap.json';
import CosmicTokenSwapAddress from '../live_artifacts/contracts/CosmicTokenSwap.sol/CosmicTokenSwap-address.json';


const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;

export function ERC20GameTokenSwapApp(): ReactElement {
  return (
    <StyledAppDiv>
      <ERC20GameTokenContract />
    </StyledAppDiv>
  );
}

export function ERC20GameTokenContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();

  const [erc20GameTokenV1Contract, setErc20GameTokenV1Contract] = useState<Contract>();
  const [erc20GameTokenV1ContractAddr, setErc20GameTokenV1ContractAddr] = useState<string>('');
  const [CFXv1Balance, setCFXv1Balance] = useState(0);

  const [erc20GameTokenV2Contract, setErc20GameTokenV2Contract] = useState<Contract>();
  const [erc20GameTokenV2ContractAddr, setErc20GameTokenV2ContractAddr] = useState<string>('');
  const [CFXv2Balance, setCFXv2Balance] = useState(0);

  const [transferAmountInput, setTransferAmountInput] = useState<string>('');


  const [cfxV1SwapQuantity, setQuantityCFXv1] = useState<string>('');
  const [cfxV2SwapQuantity, setQuantityCFXv2] = useState<string>('');
  const [swapCFXv1Button, setswapCFXv1Button] = useState<string>('APPROVE $CFXv1 & SWAP TO $CFXv2');
  const [swapCFXv2Button, setswapCFXv2Button] = useState<string>('APPROVE $CFXv2 & SWAP TO $CFXv1');

  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }
    setSigner(library.getSigner());
    
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

  //test for account change
  useEffect(() => {
    handleAttachContract();
  }, [account]);

  function handleAttachContract() {

   //is a signer is defined
    if (!signer) {
      return;
    }
    

    async function attachErc20GameTokenContract(signer: Signer): Promise<void> {

      const ERC20GameV1Token = new ethers.ContractFactory(
        ERC20GameTokenV1Artifact.abi,
        ERC20GameTokenV1Artifact.bytecode,
        signer
      );

      const ERC20GameV2Token = new ethers.ContractFactory(
        ERC20GameTokenV2Artifact.abi,
        ERC20GameTokenV2Artifact.bytecode,
        signer
      );

      try {

        const erc20GameV1TokenContract = await ERC20GameV1Token.attach(ERC20GameTokenV1Address.address);
        setErc20GameTokenV1Contract(erc20GameTokenV1Contract);
        setErc20GameTokenV1ContractAddr(erc20GameV1TokenContract.address);

        const erc20GameV2TokenContract = await ERC20GameV2Token.attach(ERC20GameTokenV2Address.address);
        setErc20GameTokenV2Contract(erc20GameTokenV2Contract);
        setErc20GameTokenV2ContractAddr(erc20GameV2TokenContract.address);


        //Chech if CFX approved and change to SWAP Button
        handleCheckApproveCFX();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachErc20GameTokenContract(signer);
  }

  function handleApproveCFXv1andSwap(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function approveCFXv1andSwap(signer: Signer): Promise<void> {
     
      const CFXV1Token = new ethers.ContractFactory(
        ERC20GameTokenV1Artifact.abi,
        ERC20GameTokenV1Artifact.bytecode,
        signer
      );

      const CosmicTokenSwap = new ethers.ContractFactory(
        CosmicTokenSwapArtifact.abi,
        CosmicTokenSwapArtifact.bytecode,
        signer
      );

      try {

        const CFXv1_Contract = await CFXV1Token.attach(ERC20GameTokenV1Address.address);

        const CosmicTokenSwap_Contract = await CosmicTokenSwap.attach(CosmicTokenSwapAddress.address);

        const amountApprovedCFXv1 = await CFXv1_Contract.allowance(account,CosmicTokenSwap_Contract.address);

        const amountApprovedCFXv1NUM = Number(ethers.utils.formatUnits(amountApprovedCFXv1,18));

        //window.alert(Number(cfxV1SwapQuantity));

        //window.alert(amountApprovedCFXv1NUM);

        const balanceCFXv1 = await CFXv1_Contract.balanceOf(account);

        //window.alert(balanceCFXv1);

        if (Number(cfxV1SwapQuantity) <= 0 ) {
          window.alert('Quantity CFXv1 to SWAP must be higher than 0');
          return;
        }

        if (Number(balanceCFXv1) < Number(ethers.utils.parseEther(cfxV1SwapQuantity))) {
          window.alert('Not enough CFXv1 Balance to SWAP to CFXv2');
          return;
        }

        //If not enough allowence left
        if (Number(amountApprovedCFXv1) < (Number(ethers.utils.parseEther(cfxV1SwapQuantity)) )) {
          //Do Approve BUSD

          window.alert('Need to Approve CFXv1');

          const approveAmount = ethers.utils.parseEther(cfxV1SwapQuantity);
          
          const setTxn = await CFXv1_Contract.approve(CosmicTokenSwapAddress.address,approveAmount);
          await setTxn.wait();

          window.alert(`Success!\n\nCFXv1 APPROVED`);

          setswapCFXv1Button('SWAP TO $CFXv2');

        }  

        const swapAmount = ethers.utils.parseEther(cfxV1SwapQuantity);
        // _pid 0 = cfxv1 to cfxv2
        const setTxnSwap = await CosmicTokenSwap_Contract.swap(swapAmount,0);
        await setTxnSwap.wait();
  
        window.alert(`Success!\n\nSwaped: ${cfxV1SwapQuantity.toString()} $CFXv1 to ${cfxV1SwapQuantity.toString()} $CFXv2`);


        //Chech if CFX approved and change to SWAP Button
        handleCheckApproveCFX();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    approveCFXv1andSwap(signer);
  }

  function handleApproveCFXv2andSwap(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function approveCFXv2andSwap(signer: Signer): Promise<void> {
     
      const CFXV2Token = new ethers.ContractFactory(
        ERC20GameTokenV2Artifact.abi,
        ERC20GameTokenV2Artifact.bytecode,
        signer
      );

      const CosmicTokenSwap = new ethers.ContractFactory(
        CosmicTokenSwapArtifact.abi,
        CosmicTokenSwapArtifact.bytecode,
        signer
      );

      try {

        const CFXv2_Contract = await CFXV2Token.attach(ERC20GameTokenV2Address.address);

        const CosmicTokenSwap_Contract = await CosmicTokenSwap.attach(CosmicTokenSwapAddress.address);

        const amountApprovedCFXv2 = await CFXv2_Contract.allowance(account,CosmicTokenSwap_Contract.address);

        const amountApprovedCFXv1NUM = Number(ethers.utils.formatUnits(amountApprovedCFXv2,18));

        //window.alert(Number(cfxV1SwapQuantity));

        //window.alert(amountApprovedCFXv1NUM);

        const balanceCFXv2 = await CFXv2_Contract.balanceOf(account);

        //window.alert(balanceCFXv1);

        if (Number(cfxV2SwapQuantity) <= 0 ) {
          window.alert('Quantity CFXv2 to SWAP must be higher than 0');
          return;
        }

        if (Number(balanceCFXv2) < Number(ethers.utils.parseEther(cfxV2SwapQuantity))) {
          window.alert('Not enough CFXv2 Balance to SWAP to CFXv1');
          return;
        }

        //If not enough allowence left
        if (Number(amountApprovedCFXv2) < (Number(ethers.utils.parseEther(cfxV2SwapQuantity)) )) {
          //Do Approve BUSD

          window.alert('Need to Approve CFXv2');

          const approveAmount = ethers.utils.parseEther(cfxV2SwapQuantity);
          
          const setTxn = await CFXv2_Contract.approve(CosmicTokenSwapAddress.address,approveAmount);
          await setTxn.wait();

          window.alert(`Success!\n\nCFXv2 APPROVED`);

          setswapCFXv2Button('SWAP TO $CFXv1');

        }  

        const swapAmount = ethers.utils.parseEther(cfxV2SwapQuantity);

        // _pid 1 = cfxv2 to cfxv1
        const setTxnSwap = await CosmicTokenSwap_Contract.swap(swapAmount,1);
        await setTxnSwap.wait();
  
        window.alert(`Success!\n\nSwaped: ${cfxV2SwapQuantity.toString()} $CFXv2 to ${cfxV2SwapQuantity.toString()} $CFXv1`);


        //Chech if CFX approved and change to SWAP Button
        handleCheckApproveCFX();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    approveCFXv2andSwap(signer);
  }
  
  function handleCheckApproveCFX(): void {
   
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function approveCheckCFX(signer: Signer): Promise<void> {

      const CFXV1Token = new ethers.ContractFactory(
        ERC20GameTokenV1Artifact.abi,
        ERC20GameTokenV1Artifact.bytecode,
        signer
      );

      const CFXV2Token = new ethers.ContractFactory(
        ERC20GameTokenV2Artifact.abi,
        ERC20GameTokenV2Artifact.bytecode,
        signer
      );

      const CosmicTokenSwap = new ethers.ContractFactory(
        CosmicTokenSwapArtifact.abi,
        CosmicTokenSwapArtifact.bytecode,
        signer
      );

      try {

        const CFXv1_Contract = await CFXV1Token.attach(ERC20GameTokenV1Address.address);
        const CFXv2_Contract = await CFXV2Token.attach(ERC20GameTokenV2Address.address);
        const CosmicTokenSwap_Contract = await CosmicTokenSwap.attach(CosmicTokenSwapAddress.address);

        const amountApprovedCFXv1 = await CFXv1_Contract.allowance(account,CosmicTokenSwap_Contract.address);
        const amountApprovedCFXv2 = await CFXv2_Contract.allowance(account,CosmicTokenSwap_Contract.address);

        const amountApprovedCFXv1NUM = Number(ethers.utils.formatUnits(amountApprovedCFXv1,18));
        const amountApprovedCFXv2NUM = Number(ethers.utils.formatUnits(amountApprovedCFXv2,18));

        //window.alert(amountApprovedCFXv1NUM);
        //window.alert(amountApprovedCFXv2NUM);
         
        const walletNewBalanceCFXv1 = await CFXv1_Contract.balanceOf(account);
        const newBalanceCFXv1 = Number(ethers.utils.formatUnits(walletNewBalanceCFXv1,18));
        const newBalanceCFXv1dig = Number(newBalanceCFXv1.toFixed(2));
        setCFXv1Balance(newBalanceCFXv1dig);

        const walletNewBalanceCFXv2 = await CFXv2_Contract.balanceOf(account);
        const newBalanceCFXv2 = Number(ethers.utils.formatUnits(walletNewBalanceCFXv2,18));
        const newBalanceCFXv2dig = Number(newBalanceCFXv2.toFixed(2));
        setCFXv2Balance(newBalanceCFXv2dig);

        //If not enough allowence left
        if (Number(amountApprovedCFXv1) > 0) {
          setswapCFXv1Button('SWAP TO $CFXv2');

        } else {
         // window.alert(`Change button to MINT $CFX`);
          setswapCFXv1Button('APPROVE $CFXv1 & SWAP TO $CFXv2');
        }

        //If not enough allowence left
        if (Number(amountApprovedCFXv2) > 0) {
          setswapCFXv2Button('SWAP TO $CFXv1');

        } else {
          // window.alert(`Change button to MINT $CFX`);
          setswapCFXv2Button('APPROVE $CFXv2 & SWAP TO $CFXv1');
        }
       
      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    approveCheckCFX(signer);
  }


  function doSetQuantityCFXv1(_amount: any): void {
    setQuantityCFXv1(_amount);
  }

  function doSetQuantityCFXv2(_amount: any): void {
    setQuantityCFXv2(_amount);
  }

  
  return (
    <>
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
          <Row className="g-4">
            <h6 className="p-1 text-center">
            Contract $CFXv1: {erc20GameTokenV1ContractAddr}
            </h6>
          </Row>
          <Row className="g-4">
            <h6 className="p-1 text-center">
            Contract $CFXv2: {erc20GameTokenV2ContractAddr}
            </h6>
          </Row>
          <Row className="g-4">
          <div>&nbsp;</div>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '520px' }}>
            <img src='./images/Swap.jpg' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
          <div>&nbsp;</div>
          </Row>
          <Row className="g-4">
            <h5 className="p-1 text-center">
              1 $CFXv1 = 1 $CFXv2
            </h5>
          </Row>
          <Row className="g-4">
            <h5 className="p-1 text-center">
              1 $CFXv2 = 1 $CFXv1
            </h5>
          </Row>
          <Row className="g-4">
            <h6 className="p-2 text-center">
              ZERO TRANSFER TAX WILL APPLY
            </h6>
          </Row>
          <Row className="g-4">
            <h6>
              Balance: {CFXv1Balance} CFXv1
            </h6>
          </Row>
            <Row className="g-4">
            <Col xs={5}>
              <Form.Control onChange={(e) => setQuantityCFXv1(e.target.value)} size="lg" required type="number" placeholder="Qty $CFXv1 to SWAP to $CFXv2" />
            </Col>
            <Col>
              <div className="d-grid px-0">
                <Button onClick={handleApproveCFXv1andSwap} variant="primary" size="lg">
                  {swapCFXv1Button}
                </Button>
              </div>
              <div className="d-grid px-0 center"> 

              </div>
            </Col>
            </Row>
            <Row className="g-4">
              <div>&nbsp;</div>
            </Row>
            <Row className="g-4">
            <h6>
              Balance: {CFXv2Balance} CFXv2
            </h6>
          </Row>
            <Row className="g-4">
            <Col xs={5}>
              <Form.Control onChange={(e) => setQuantityCFXv2(e.target.value)} size="lg" required type="number" placeholder="Qty $CFXv2 to SWAP to $CFXv1" />
            </Col>
            <Col>
              <div className="d-grid px-0">
                <Button onClick={handleApproveCFXv2andSwap} variant="primary" size="lg">
                  {swapCFXv2Button}
                </Button>
              </div>
              <div className="d-grid px-0 center"> 

              </div>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            CFXv1 is used for the presale purchase of BITCORE, PLATECORE, STACKCORE, DUALSTACKCORE, PLANET and NODE NFTs.
            </h6>
            </Row>
            <div>&nbsp;</div>
            </div>
        </main>
      </div>
    </div>
    </>
  );
}
